import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export default function CustomDatePicker({ selectedDate, setSelectedDate, inputRef, label }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={selectedDate}
        onChange={(newValue) => setSelectedDate(newValue)}
        format="yyyy-MM-dd"
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            inputRef,
            inputProps: {
              readOnly: true,
              style: {
                cursor: "pointer",
                fontSize: "11px",
              },
              onClick: () => {
                if (inputRef?.current) {
                  inputRef.current.focus();
                  const event = new KeyboardEvent("keydown", { key: "ArrowDown" });
                  inputRef.current.dispatchEvent(event);
                }
              },
            },
            InputLabelProps: {
              sx: { fontSize: '14px', fontWeight: "bold" }, // 라벨 텍스트 크기 조정
            },
          },
        }}
        sx={{
          width: 125,
          '& .MuiInputBase-root': {
            height: 40,
            cursor: 'pointer'
          }
        }}
      />
    </LocalizationProvider>
  );
}